export default __webpack_public_path__ + "9b096378b7eaab074e0d29950315ba7f.jpg";